import React, { Component } from "react";

class TheProblem extends Component {
  render() {
    const { title, chip, content = [], role, timeline, team, img } = this.props;

    const imgStyle = {
      backgroundImage: "url(" + { img } + ")",
      backgroundSize: "cover",
    };

    return (
      <div className="container">
        <div className="row middle-sm img-container">
          <div className="col-md-5" style={{ paddingRight: 24 }}>
            {chip && <span className="chip">{chip}</span>}
            {title && <h2>{title}</h2>}
            {Array.isArray(content) &&
              content.map((paragraph, index) =>
                paragraph ? (
                  <p key={index} className="lead">
                    {paragraph}
                  </p>
                ) : null
              )}
            {role && (
              <div>
                <p>
                  <b>My Role</b>
                  <br />
                  {role}
                </p>
              </div>
            )}
            {timeline && (
              <div>
                <p>
                  <b>Timeline</b>
                  <br />
                  {timeline}
                </p>
              </div>
            )}
            {team && (
              <div>
                <p>
                  <b>Team</b> <br />
                  {team}
                </p>
              </div>
            )}
          </div>
          <div className="col-md-7 col-img">
            {img && (
              <img
                src={img}
                width="100%"
                alt="content visual"
                className="img-shadow"
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default TheProblem;
